;(function(EG) {
  'use strict';

  EG.Users.Profile.Models.CDFDefinition = EG.Users.Models.Base.extend({
    defaults: {
      id: undefined,
      name: undefined,
      company_id: undefined,
      product_id: undefined,
      code: undefined,
      status: undefined,
      rules: undefined,
      min_length: undefined,
      max_length: undefined,
      field_type: undefined,
      created_by: undefined,
      created_at: undefined,
      updated_by: undefined,
      updated_at: undefined,
      legacy_list_id: undefined,
      rank: undefined
    }
  });

  EG.Users.Profile.Collections.CDFDefinitions = EG.Users.Collections.Base.extend({
    model: EG.Users.Profile.Models.CDFDefinition,

    url: function() {
      var url;

      url = '/users/pb/companies/' + this.companyId + '/cdfs';

      return url;
    },
    initialize: function(models, options) {
      this.companyId = options.companyId;
    },
    fetchData: function() {
      var defer, self;
      defer = $.Deferred();
      self = this;

      self.fetch({
        success: function(collection, response, options) {
          defer.resolve(response.cdfs);
        },
        error: function(collection, response, options) {
          var errorMsg;

          errorMsg = EG.Users.Constants.KIBANA_ERROR_MESSAGE_FOR_FETCH;

          errorMsg = errorMsg.replace('{Module}', 'CDF');
          errorMsg = errorMsg.replace('{component}', 'cdf definitions');
          errorMsg = errorMsg.replace('{url}', self.url());
          uitk.logger.error(errorMsg);
          defer.reject(response);
        }
      });

      return defer.promise();
    }
  });
})(EG);
